module.exports = __webpack_public_path__ + "img/bg_image.e6df1aff.jpeg";